import { Chevron } from '../';
import * as React from 'react';
import './Pagination.scss';
const classnames = require('classnames');

interface Props {
  page: number;
  maxPage: number;
  goToPrevPage();
  goToNextPage();
}

export const Pagination = (props: Props) => {
  const isFirstPage = props.page === 1;
  const isLastPage = props.page === props.maxPage;

  const leftClasses = classnames({ 'noble-pagination-disabled': isFirstPage });
  const rightClasses = classnames({ 'noble-pagination-disabled': isLastPage });

  const onClickLeft = isFirstPage ? null : props.goToPrevPage;
  const onClickRight = isLastPage ? null : props.goToNextPage;

  return (
    <td className='noble-pagination'>
      <Chevron direction='left' className={leftClasses} onClick={onClickLeft} />
      <span className='noble-pagination-number'>{props.page}</span>
      <Chevron direction='right' className={rightClasses} onClick={onClickRight} />
    </td>
  );
};
